import {createContext} from 'react'

import {AccordionContextValue} from './types'

export const AccordionContext = createContext<AccordionContextValue | null>(null)
